<template>
	<page class="aboutus">
		<zui-header>
		</zui-header>
		<PageNavigater></PageNavigater>
		<cms-article-list :pid="$cid.aboutus.guanYuWoMen" :limit="1" class="one">
			<template slot-scope="{list}">
				<div class="title">关于我们</div>
				<div class="contain" v-if="list.length > 0">
					<div class="content" v-html="list[0].content"></div>
					<div class="button-tentent flex">
						<div class="kuang">
							<div class="kuangFirst">峨眉山风景区管委会</div>
							<div class="kuangText">网站主办</div>
						</div>
						<div class="kuang">
							<div class="kuangFirst">峨眉山旅游股份有限公司</div>
							<div class="kuangText">网站运营</div>
						</div>
					</div>
				</div>
			</template>
		</cms-article-list>

		<div class="two">
			<div class="contain flex">
				<div class="title">
					<img :src="icon" alt="">
					<div class="text">历史荣誉</div>
				</div>
				<cms-article-list :pid="$cid.aboutus.liShiRongYu" class="line">
					<template slot-scope="{list}">
						<el-timeline>
							<el-timeline-item color="#d6ba71" size="large" :timestamp="item.ext1" placement="top"
								v-for="item in list" :key="item.id">
								<el-card>
									<p class="content_t">{{ item.intro }}</p>
									<p class="content_p">{{ item.title }}</p>
								</el-card>
								<div class="img"><cms-image :src="item.cover"></cms-image></div>
							</el-timeline-item>
						</el-timeline>
					</template>
				</cms-article-list>
			</div>
		</div>
		<zui-footer />
	</page>
</template>
<script>
	import './less/aboutus.css'
	import Logo from '../components/Logo'
	import ZuiButton from '../components/Button'
	import icon1 from '../assets/img/icon1.png'
	import arrowGrey from '../assets/img/arrow-grey.png'
	import add from '../assets/img/add.png'
	// import Util from '../Util'
	export default {
		components: {
			Logo,
			ZuiButton,
		},
		data() {
			return {
				icon: require('../assets/img/two-icon.png'),
				cmsImg: require('../assets/img/img-about.jpg'),
			}
		},
		methods: {}

	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/aboutus.vue